import { SgvJson } from '@eceos/arch';

export class PendingReceivable {
  constructor(
    public id = '',
    public description = '',
    public value: number = 0,
    public dueDate: Date = null,
    public customerName = ''
  ) {}

  static fromJson(json: any): PendingReceivable {
    return SgvJson.from.simple(json, PendingReceivable, {
      dueDate: json.dueDate ? new Date(json.dueDate) : null
    });
  }
}
